import { getActionsDropdownConfig } from '@shared/products-core';
import { isFeatureEnabled } from '@luna/gatekeeper';

/**
 * Returns whether PAPI customization is enabled.
 *
 * - If `registerType` matches a registered `actionsDropdown` config (external product),
 *   uses that product's own predicate; the global flag is ignored.
 * - Otherwise falls back to the global `product.papiCustomization` flag.
 */
export const isProductPapiCustomizationEnabled = (registerType?: string): boolean => {
    const actionsDropdownConfig = getActionsDropdownConfig(registerType);

    if (actionsDropdownConfig) {
        return actionsDropdownConfig.isPapiCustomizationEnabled?.() ?? false;
    }

    return isFeatureEnabled((f) => f.product.papiCustomization);
};
